import React, { useContext } from 'react';
import { NewWindowAnchor } from '@xo-union/component-standard-elements';
import { Room } from '../../libs/gs-component-hotel-planner';
import styles from './AddToWebsite.scss';
import { TrackingContext } from '../../TrackingContext';

interface AddToWebsiteProps {
  onClick: (room: Room) => void;
  propertyId: string;
}

const AddToWebsite: React.FC<AddToWebsiteProps> = ({ onClick, propertyId }) => {
  const { track } = useContext(TrackingContext);

  const onClickHandler = (room: Room) => {
    track('Item Action Initiated', {
      action: 'hotel_added',
      actionName: 'hotel_added_carousel',
    });

    onClick(room);
  };

  return (
    <NewWindowAnchor
      tabIndex="0"
      onClick={onClickHandler}
      className={styles.addToWebsiteLink}
      data-testid={`testAddToWebsite_${propertyId}`}
    >
      + Add To Website
    </NewWindowAnchor>
  );
};

export default AddToWebsite;
